module.exports = __webpack_public_path__ + "img/pro_s3_img1.bd4edd85.jpg";